import Layout from '../../components/Layout/Layout';
import Mouse from '../../components/Mouse/Mouse.jsx';
import ScrollTop from '../../components/ScrollTop/ScrollTop.jsx';
import FlatTitle from '../LandingPage/components/ContactUs/components/FlatTitle.jsx';
import './BehavioralObjectives.scss';
import EvaluationCriteria from './components/EvaluationCriteria/EvaluationCriteria';
import EvaluationRate from './components/EvaluationRate/EvaluationRate';
import useBehavioralObjectives from './logic/useBehavioralObjectives.js';
import { Alert, Popconfirm, Spin } from 'antd';

const userPhoto = "https://prod-discovery.edx-cdn.org/media/course/image/b43f2cde-b38f-4717-8399-033f0aba61f4-bd6f44692f21.small.png";

function BehavioralObjectives() {
    const {
      data,
      isFetching,
      error,
      setValue,
      getValues,
      submitObjectives,
    } = useBehavioralObjectives();

    return (
        <>
            <FlatTitle pageName={"Behavioral Objectives  Evaluation"} />
      <div className="section-container">
        <div id="wrapper">
            <div className="page-content">
                <Spin spinning={isFetching} />
                {
                    error ? <Alert message="An error has occurred" type="error" showIcon />
                        : (!isFetching && !error && data.users.length && data.objectives.length)
                        ?
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="horizontal-scroll-container">
                                <div className="eval-part">
                                    <div className="eval-questions">
                                        <div className="question">
                                            {data.objectives.map((item, index) => (
                                                <EvaluationCriteria key={index}>
                                                    {item.objective}
                                                </EvaluationCriteria>

                                            ))}
                                        </div>
                                    </div>
                                    <div className="scroll-content-behav">
                                        {data.users.map((participant, participantIndex) => (
                                            <div key={participantIndex} className="participants">
                                                <div className="photo"><img src={userPhoto} alt="participant"></img></div>
                                                <div className="objective">{participant.firstName} {participant.lastName}</div>
                                                <div className="evaluation-rate">
                                                    {data.objectives.map((objective, questionIndex) => (
                                                        <EvaluationRate key={questionIndex} setValue={setValue} getValues={getValues} objectiveId={objective.id} userId={participant.id} />
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="submit-btn-container">
                                    <Popconfirm
                                        title="Are you sure you want to submit?"
                                        onConfirm={submitObjectives}
                                        okText="Yes"
                                        cancelText="No"
                                    >

                                        <button type='submit' className="submit-button">Submit</button>
                                    </Popconfirm>
                            </div>
                        </form>
                        : <Alert message="No data was found." type="info" showIcon />
                }                             
            </div>
                    <Mouse />
                    <ScrollTop />
                </div>
            </div>
        </>
    );
}

export default BehavioralObjectives;
